import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomeModule } from './home/home.module';
import { AuthModule } from './auth/auth.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from './auth/error.interceptor';
import { JwtInterceptor } from './auth/jwt.interceptor';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { LandingModule } from './landing/landing.module';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { MatDividerModule } from '@angular/material/divider';
import { ErrorComponent } from './error/error.component';
import { MatRippleModule } from '@angular/material/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ModerationModule } from './moderation/moderation.module';
import { GtagModule } from 'angular-gtag';
import { ThemeService } from './common/theme/theme.service';
import { NgxStripeModule } from 'ngx-stripe';
import { environment } from '../environments/environment';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsComponent } from './terms/terms.component';
import { CommonModule } from './common/common.module';
import { MatDialog } from '@angular/material/dialog';
import { MobileWarningComponent } from './common/mobile-warning/mobile-warning.component';
import { AwaitingVerificationComponent } from './awaiting-verification/awaiting-verification.component';

@NgModule({
    declarations: [
        AppComponent,
        BreadcrumbComponent,
        ErrorComponent,
        PrivacyComponent,
        TermsComponent,
        AwaitingVerificationComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HomeModule,
        AuthModule,
        LandingModule,
        MatSidenavModule,
        MatToolbarModule,
        MatIconModule,
        MatMenuModule,
        MatButtonModule,
        MatRippleModule,
        DragDropModule,
        MatDividerModule,
        ModerationModule,
        GtagModule.forRoot({trackingId: 'G-GW1VCNEKT2', trackPageviews: true}),
        NgxStripeModule.forRoot(environment.stripePublishableKey),
        CommonModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true
        },
        ThemeService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {

    constructor(private readonly dialog: MatDialog) {
        // eslint-disable-next-line no-magic-numbers
        if (window.innerWidth <= 1199) {
            this.dialog.open(MobileWarningComponent, {width: '100vw', height: '100vh'});
        }
    }
}
